
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-seekers/featured-employers",
      function () {
        return require("private-next-pages/job-seekers/featured-employers/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-seekers/featured-employers"])
      });
    }
  